// extracted by mini-css-extract-plugin
export default {"profile__image":"AuthImage_profile__image__aMK99"};